import * as actions from './actions';
import { Category } from '@common/types/categories/category';
import { ErrorAction } from '../common/error-action';
import { LoadingAction } from '../common/loading-action';
import { Country } from '@common/types/data/country';

export class ListCategories implements LoadingAction {
  readonly type = actions.LIST_CATEGORIES;
  readonly isLoading = true;
  constructor(public contentType: string) {}
}

export class ListCategoriesSuccess implements LoadingAction {
  readonly type = actions.LIST_CATEGORIES_SUCCESS;
  readonly isLoading = false;

  constructor (public contentType: string, public categories: Category[]) {}
}

export class ListCategoriesError implements ErrorAction {
  readonly type = actions.LIST_CATEGORIES_ERROR;
  readonly isError = true;

  constructor (public code: string) {}
}

export class ListCountries implements LoadingAction {
  readonly type = actions.LIST_COUNTRIES;
  readonly isLoading = true;
}

export class ListCountriesSuccess implements LoadingAction {
  readonly type = actions.LIST_COUNTRIES_SUCCESS;
  readonly isLoading = false;

  constructor (public countries: Country[]) {}
}

export class ListCountriesError implements ErrorAction {
  readonly type = actions.LIST_COUNTRIES_ERROR;
  readonly isError = true;

  constructor (public code: string) {}
}

export class SearchCategories implements LoadingAction {
  readonly type = actions.SEARCH_CATEGORIES;
  readonly isLoading = true;

  constructor(public contentType: string, public query: string) {}
}

export class SearchCategoriesSuccess implements LoadingAction {
  readonly type = actions.SEARCH_CATEGORIES_SUCCESS;
  readonly isLoading = false;

  constructor (public contentType: string, public categories: Category[]) {}
}

export class SearchCategoriesError implements ErrorAction {
  readonly type = actions.SEARCH_CATEGORIES_ERROR;
  readonly isError = true;

  constructor (public code: string) {}
}

export type CategoriesActions = 
  | ListCategories | ListCategoriesSuccess | ListCategoriesError
  | ListCountries | ListCountriesSuccess | ListCountriesError
  | SearchCategories | SearchCategoriesSuccess | SearchCategoriesError;